import React from "react";
import { IconButton } from "@libertify/ui";
import { PauseIcon, PlayIcon } from "@phosphor-icons/react";

export interface VoicePreviewButtonProps {
  previewUrl: string | null;
  playing: boolean;
  onToggle: () => void;
}

/** Icon-only play/pause for a voice option row — no seek, just a taste. */
export const VoicePreviewButton: React.FC<VoicePreviewButtonProps> = ({
  previewUrl,
  playing,
  onToggle,
}) => (
  <IconButton
    variant="tertiary"
    size="s"
    shape="round"
    disabled={!previewUrl}
    // The row itself is a clickable antd option — without this, playing a
    // preview also selects that voice.
    onClick={(event) => {
      event.stopPropagation();
      onToggle();
    }}
    icon={
      playing ? (
        <PauseIcon size={14} weight="fill" />
      ) : (
        <PlayIcon size={14} weight="fill" />
      )
    }
  />
);

export default VoicePreviewButton;
